import React from 'react'
import PageBody from 'components/app/PageBody'
import CompanyContainer from 'components/company/view/CompanyContainer'

export default function CompanyPage() {
  return <PageBody renderContent={() => <CompanyContainer />} />
}
